<div class="flex gap-7 h-full items-end ">
  <div class="bg-white w-1/2 h-full rounded-lg p-8 flex flex-col gap-8">
    <div class="font-bold text-3xl capitalize">
      {{title}}
    </div>
    <div class="h-full flex gap-8">
      <div class="w-1/2 flex flex-col gap-2.5 h-full0">
        <div class="flex items-center bg-gray-100 gap-2 p-2 rounded font-bold text-lg">
          <img src="/icons/appt-type/queue.svg" class="h-8" >
          <div>
            {{categoriesText.queue}}
          </div>
        </div>
        <div class="flex flex-col gap-4 py-2 px-4">
          @for(appt of filteredEvents().queue; track $index){
            <div class="text-[32px] font-bold uppercase">{{appt.customerName}}</div>
          }
        </div>
      </div>
      <div class="w-1/2 flex flex-col gap-2.5 h-full">
        <div class="flex items-center bg-gray-100 gap-2 p-2 rounded font-bold text-lg">
          <img src="/icons/appt-type/appointment.svg" class="h-8" >
          <div>
            {{categoriesText.appointment}}  
          </div>
        </div>
        <div class="flex flex-col gap-4 py-2 px-4">
          @for(appt of filteredEvents().appointment; track $index){
            <div class="text-[32px] font-bold uppercase">{{appt.customerName}}</div>
          }
        </div>
      </div>
    </div>
    <div class="text-sm text-center">{{categoriesText.footer}}</div>
  </div>

  @if(settingsServices.settings().allow_device && settingsServices.settings().allow_device.enabled){
    <div class="bg-white w-1/5 h-1/2 rounded-lg px-4 py-6 flex flex-col gap-3">
      <div class="font-bold text-xl text-center">{{categoriesText.qr.title}}</div>
      <div class="flex items-stretch justify-center h-full">

        <qr-code
        [value]="linkQR"
        [margin]="0"
        errorCorrectionLevel="H" />
      </div>
      <div class="text-sm text-center">{{categoriesText.qr.footer}}</div>
    </div>
  }
</div>
